import React from 'react';
import PreDeliveringContainer from './PreDeliveringContainer';

const Tiktok = (props) => (
  <PreDeliveringContainer
    createdSource="tiktok"
    title="TikTok Pre-Delivering List"
    {...props}
  />
);

export default Tiktok;
